import { tw } from "@utils/tailwind";

export const marginBottomWrapperStyles = tw`mb-8 md:mb-10 xl:mb-14`;
